import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { scheduleCalculationServices } from 'services/CalculationServices/scheduleCalculationsServices';

export class ScheduleCalculationsStore {
  scheduleCalculation: any = null;
  roomScheduleCalculations: any[] = [];
  dateScheduleCalculations: any = {};
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchScheduleCalculation = async (jobId: string) => {
    this.isLoading = true;
    try {
      const response = await scheduleCalculationServices.getScheduleCalculationForJob(jobId);

      runInAction(() => {
        if (response.success) {
          this.scheduleCalculation = response.data;
        } else {
          this.scheduleCalculation = null;
          toast.error('Failed to fetch schedule calculation');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.scheduleCalculation = null;
        toast.error('Error fetching schedule calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchRoomScheduleCalculations = async (room: string, date?: string) => {
    this.isLoading = true;
    try {
      const response = await scheduleCalculationServices.getScheduleCalculationsForRoom(room, date);

      runInAction(() => {
        if (response.success) {
          this.roomScheduleCalculations = response.data;
        } else {
          this.roomScheduleCalculations = [];
          toast.error('Failed to fetch room schedule calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.roomScheduleCalculations = [];
        toast.error('Error fetching room schedule calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchDateScheduleCalculations = async (date: string) => {
    this.isLoading = true;
    try {
      const response = await scheduleCalculationServices.getScheduleCalculationsForDate(date);

      runInAction(() => {
        if (response.success) {
          this.dateScheduleCalculations = response.data;
        } else {
          this.dateScheduleCalculations = {};
          toast.error('Failed to fetch date schedule calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.dateScheduleCalculations = {};
        toast.error('Error fetching date schedule calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  updateScheduleCalculation = async (scheduleCalcId: number, data: any) => {
    this.isLoading = true;
    try {
      const response = await scheduleCalculationServices.updateScheduleCalculation(
        scheduleCalcId,
        data
      );

      runInAction(() => {
        if (response.success) {
          this.scheduleCalculation = response.data;
          toast.success('Schedule calculation updated successfully');
        } else {
          toast.error('Failed to update schedule calculation');
        }
      });
    } catch (error) {
      runInAction(() => {
        toast.error('Error updating schedule calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  // Reset store data
  reset = () => {
    this.scheduleCalculation = null;
    this.roomScheduleCalculations = [];
    this.dateScheduleCalculations = {};
    this.isLoading = false;
  };
}
